import axios from "axios";
import { Credencials } from "../interfaes/user";

export async function onHandelLogin(obj: Credencials) {

    return await axios.post(
        '/auth/login',
        obj
    );
}

export async function onForgotPassword(mobile: string) {
    return await axios.post('/auth/forgot-password', { mobile });
}

export async function onVerifyOtp(mobile: string, otp: string) {
    return await axios.post('/auth/verify-otp', { mobile, otp });
}

export async function onResetPassword(obj: any) {
    return await axios.post('/auth/reset-password', obj);
}
